import React, { createContext, useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import APILogout from "../components/api/APILogout"; //fix this, not being used
import {host} from "./../components/utils";
import Cookies from "universal-cookie";
import axios from "axios";
import { useToasts } from "react-toast-notifications";

const cookies = new Cookies();

const AuthContext = createContext();
export default AuthContext;

export const AuthProvider = ({ children }) => {
  var currentDate = new Date();
  let storageString = localStorage.getItem("authTokens");
  let userToken;
  let isAdminCheck = false;
  let decodedToken = { exp: null };
  let accessToken = null;

  const { addToast } = useToasts();

  if (storageString) {
    userToken = JSON.parse(storageString);
    decodedToken = jwt_decode(userToken.access);
    isAdminCheck = userToken.staff;
    accessToken = userToken.access;
  }

  let [isAdmin, setIsAdmin] = useState(true);
  let [viewAsAdmin, setViewAsAdmin] = useState(true);

  let [authToken, setAuthToken] = useState(accessToken);

  let [isAuthenticated, setIsAuthenticated] = useState(
    // decodedToken.exp * 1000 > currentDate.getTime() ? true : false
    true
  );

  let [user, setUser] = useState(() =>
    localStorage.getItem("authTokens")
      ? jwt_decode(localStorage.getItem("authTokens"))
      : null
  );

  const APIAuth = axios.create({
    baseURL: `${host}/api`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": cookies.get("csrftoken"),
    },
    credentials: "same-origin",
  });

  let logoutUser = () => {
    // console.log("logging out from authcontext");
    if (isAuthenticated) {
      addToast(`Logged out successfully`, { appearance: "success" });
    }
    setIsAuthenticated(false);
    setAuthToken(null);
    setUser(null);
    setIsAdmin(false);
    setUser(null);
    localStorage.removeItem("authTokens");
    //call logout api route
    APIAuth.post("/logout").then((response) => {});
  };

  let contextData = {
    user: user,
    viewAsAdmin: viewAsAdmin,
    setViewAsAdmin: setViewAsAdmin,
    authToken: authToken,
    setAuthToken: setAuthToken,
    isAdmin: isAdmin,
    setIsAdmin: setIsAdmin,
    logoutUser: logoutUser,
    isAuthenticated: isAuthenticated,
    setIsAuthenticated: setIsAuthenticated,
  };
  // console.log("in authcontext");

  useEffect(() => {
    // console.log("useffect at authcontext");
  }, []);

  return (
    <AuthContext.Provider value={contextData}>
      {/* {loading ? null : children} */}
      {children}
    </AuthContext.Provider>
  );
};
